import { Capacitor } from "@capacitor/core";
import { FEATURE_FLAGS } from "@/config/featureFlags";

export function isIOSNative(): boolean {
  return Capacitor.getPlatform() === "ios";
}

// Apple App Store Guideline 3.1.1: forbids any external payment CTA in native iOS builds.
// VYV sells subscriptions on web only (Asaas). All payment UI must be invisible on iOS native.
// Every payment surface gates on this single function — to flip-in IAP later, change only here.
export function isPaymentUiBlocked(): boolean {
  return isIOSNative();
}

// Native In-App Purchase (RevenueCat / StoreKit) availability.
// SEPARATE from isPaymentUiBlocked() on purpose: that one hides EXTERNAL
// payment surfaces (Asaas PIX/card, aivyv.com steering, credit packs) on iOS
// and must stay true; this one turns ON the compliant in-app StoreKit path.
// True only on iOS native AND when the NATIVE_IAP_ENABLED flag is on.
export function isNativeIapEnabled(): boolean {
  return isIOSNative() && FEATURE_FLAGS.NATIVE_IAP_ENABLED;
}
